import React, { memo } from 'react';
import { FBMediaProps, FBMPIProcedureItemProps, FBProcedureItemConfig, FBProcedureItemType } from '..';
import FBEquipmentTable from '../FBEquipmentTable/components/treelist';
import MaterialsTable from '../FBMaterialsTable/MaterialTable';
import FBMPIProcedureItemSerialsTable from '../FBMPIProcedureItemSerialsTable';
import Attachments from './components/attachments';

const EMPTY_ITEMS: FBProcedureItemConfig[] = [];

const FBMPIProcedureItem: React.FC<FBMPIProcedureItemProps> = ({
  handleRemove,
  handleSelectionDelete,
  getItem,
  isPreview,
  disabled = false,
  isFieldDisabled = false,
  type,
  stepIndex,
  value = EMPTY_ITEMS,
  name,
  isSelectVisible,
  defaultValue,
  redlineActive,
  isDesign,
  isDocumentMPI,
  isDeviationMode,
  hideDeviationChanges,
  baseEditorConfig,
  deviationAttachmentIds,
}) => {
  switch (type) {
    case FBProcedureItemType.attachments:
      return (
        <Attachments
          stepIndex={stepIndex}
          name={name}
          defaultValue={defaultValue}
          highlightedDeviationIds={deviationAttachmentIds}
          removedDeviationIds={(!hideDeviationChanges && baseEditorConfig)
            ? (baseEditorConfig.attachments ?? [])
              .filter((b) => !(defaultValue as FBMediaProps[] | undefined)?.some((a) => a.id === b.id))
              .map((b) => b.id)
            : undefined}
        />
      );
    case FBProcedureItemType.materials:
      return (
        <MaterialsTable
          name={name}
          isEnableOnlyLotAddition={isSelectVisible && !redlineActive}
          isActive={!isPreview}
          type={type}
          isDisabled={disabled}
          isDesign={isDesign}
          items={value}
          getItem={getItem}
          handleRemove={handleRemove}
          handleSelectionDelete={handleSelectionDelete}
          isMPIProcedure={isDocumentMPI}
          isPreview={isPreview}
          isDeviationMode={isDeviationMode}
          hideDeviationChanges={hideDeviationChanges}
          baseItems={baseEditorConfig ? (baseEditorConfig.materials ?? []) : undefined}
        />
      );
    case FBProcedureItemType.equipment:
      return (
        <FBEquipmentTable
          name={name}
          isDisabled={disabled}
          type={type}
          items={value}
          getItem={getItem}
          handleRemove={handleRemove}
          handleSelectionDelete={handleSelectionDelete}
          isDesign={isDesign}
          isPreview={isPreview}
          isMPIProcedure={isDocumentMPI}
          isEnableActualIdAddition={isSelectVisible && !redlineActive}
          isDeviationMode={isDeviationMode}
          hideDeviationChanges={hideDeviationChanges}
          baseItems={baseEditorConfig ? (baseEditorConfig.equipment ?? []) : undefined}
        />
      );
    case FBProcedureItemType.serials:
      return (
        <FBMPIProcedureItemSerialsTable
          name={name}
          isDisabled={isFieldDisabled}
          sequenceIndex={stepIndex}
          isDocumentMPI={isDocumentMPI}
        />
      );
    default:
      return null;
  }
};

export default memo(FBMPIProcedureItem);
